import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

export function useAssignConversation(brandId: string, conversationId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string | null) =>
      apiFetch<{ conversation: any }>(
        `/brands/${brandId}/inbox/conversations/${conversationId}/assign`,
        { method: "POST", body: JSON.stringify({ userId }) },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["inbox-conversation", brandId, conversationId] });
      qc.invalidateQueries({ queryKey: ["inbox-conversations", brandId] });
    },
  });
}

export function useSetConversationStatus(brandId: string, conversationId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      status: "OPEN" | "SNOOZED" | "DONE" | "ARCHIVED";
      snoozedUntil?: string;
    }) =>
      apiFetch<{ conversation: any }>(
        `/brands/${brandId}/inbox/conversations/${conversationId}/status`,
        { method: "POST", body: JSON.stringify(input) },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["inbox-conversation", brandId, conversationId] });
      qc.invalidateQueries({ queryKey: ["inbox-conversations", brandId] });
    },
  });
}

/**
 * List-level status change keyed by conversationId at call time (not at hook
 * creation) — used by the "Hide/Archive" action on each conversation row and
 * its Undo. Refreshes the conversation list + unread badge.
 */
export function useArchiveConversation(brandId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      conversationId: string;
      status: "ARCHIVED" | "OPEN";
    }) =>
      apiFetch<{ conversation: any }>(
        `/brands/${brandId}/inbox/conversations/${input.conversationId}/status`,
        { method: "POST", body: JSON.stringify({ status: input.status }) },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["inbox-conversations", brandId] });
      qc.invalidateQueries({ queryKey: ["inbox-unread", brandId] });
    },
  });
}
